// extracted by mini-css-extract-plugin
export default {"container":"Welcome_container__PoQL9","headshot":"Welcome_headshot__mZKZz","buttons":"Welcome_buttons__vfzAJ","hero":"Welcome_hero__08Vjc"};